import { fetchUploadedReceiptsByReceiptId } from '../../../../graphql/custom_queries';
import PropTypes from 'prop-types';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

export const fetchUploadedReceipts = async (receiptId) => {
  try {

    const gqlParams = {
      receiptId: receiptId,
    };

    // console.info('GraphQL Params:', gqlParams);

    const response = await client.graphql({
      query: fetchUploadedReceiptsByReceiptId,
      variables: gqlParams,
    });

    // console.info('GraphQL Response:', response);

    // Ensure response is as expected
    if (!response || !response.data || !response.data.transactionReceiptDocumentLinksByReceiptId) {
      console.warn(`No data returned for status ${status}`);
      return null; // Return null if the response structure is unexpected
    }

    const results = response.data.transactionReceiptDocumentLinksByReceiptId.items;

    // If results is not an array or is empty, return null
    if (!Array.isArray(results) || results.length === 0) {
      console.warn('No results found.');
      return null;
    }

    return results; // Return the items array if data is present
  } catch (err) {
    console.error('Error in fetchUploadedReceipts:', err);
    return null; // Return null on error
  }
};

fetchUploadedReceipts.propTypes = {
  receiptId: PropTypes.string.isRequired,
};